import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './CommonLeasingButton.css';

class CommonLeasingButton extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
    //
    title: PropTypes.string,
    className: PropTypes.string,
    prefix: PropTypes.string,
    showInfoIcon: PropTypes.bool,
    children: PropTypes.node,
  };

  static defaultProps = {
    className: '',
    onClick: () => {},
    title: '',
    prefix: '',
    showInfoIcon: true,
    children: null,
  };

  render() {
    const { title, showInfoIcon, onClick, prefix, className, children } = this.props;
    return (
      <React.Fragment>
        {!children &&
          <div onClick={onClick} className={`leasing-btn ${className} ${s.root}`}>
            {prefix &&
              <div className={s.prefix}>
                {prefix}
              </div>}
            {!children &&
              <div className={s.title}>
                {title}
              </div>}
            {showInfoIcon &&
              <div className={s.icon}>
                <i className={`fa fa-info`} />
              </div>}
          </div>}
        {children &&
          <div onClick={onClick} className={`leasing-btn ${className}`}>
            {children}
          </div>}
      </React.Fragment>
    );
  }
}

export default withStyles(s)(CommonLeasingButton);



// WEBPACK FOOTER //
// ./src/shared/components/LeasingOnlineBanner/CommonLeasingButton/CommonLeasingButton.js